import DtoConverter from 'scripts/application/dto_converters/search/search_result_converter';
import qconsole from 'scripts/lib/qconsole';

export const SEARCH_RESULT_INTERVAL_MS = 15000;

export default class UniversalSearchResultGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  get store() {
    return this.context.stores.universalSearchResults;
  }

  handleSearchResult(dto) {
    this.clearExpiredResults();
    this.addSearchResult(dto);
  }

  handleSearchResultError(errorDto) {
    qconsole.log(`Failed to fetch search results ${JSON.stringify(errorDto)}`);
  }

  addSearchResult(dto) {
    this.store.addOrReplace(DtoConverter.fromDto(dto));
  }

  clearExpiredResults() {
    const now = new Date();
    const results = this.store.findAll();
    results.forEach(result => {
      const createdAt = new Date(result.requestedAt);
      if (now - createdAt > SEARCH_RESULT_INTERVAL_MS) {
        this.store.remove(result.id);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/search/universal_search_result_gateway_observer.js